import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type AlertBoxDismissModeEnum,
	type PortfolioEventTypeEnum,
	postPortfolioIdAlertBoxesV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type DismissVariables = {
	contractId: number;
	eventType: PortfolioEventTypeEnum;
	eventDate: string;
	mode: AlertBoxDismissModeEnum;
};

/**
 * Persists an Event Alert dismissal server-side (temporary or permanent). The
 * backend owns the re-show / expiry rules, so on success we just invalidate the
 * contract's alert-box queries to refetch the up-to-date list.
 */
export const useDismissPortfolioAlertMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, DismissVariables>({
		mutationFn: processResponse(
			({ contractId, eventType, eventDate, mode }: DismissVariables) =>
				postPortfolioIdAlertBoxesV2(
					{ eventType, eventDate, dismissed: true, mode },
					contractId,
				),
		),
		onSuccess: (_data, { contractId }) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.alertBoxesAll(contractId),
			});
		},
	});
};
